import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useId } from 'react';
import { formMessages } from '../../messages';
import type { InputID } from '../types';

/**
 * Gather the basic props (that only depend on the id) for each input
 */
export const useGetFieldProps = (
  register: UseFormRegister<{
    pause?: string | undefined;
    email: string;
    frequency: string;
  }>,
  errors: FieldErrors,
) => {
  const { formatMessage } = useIntl();
  const uniqueId = useId();
  return (inputId: InputID) => {
    const currentLabel = formatMessage(formMessages[inputId]?.label);

    return {
      ...register(inputId),
      id: `${inputId}-${uniqueId}`,
      helperText: errors[inputId]?.message?.toString(),
      label: currentLabel !== (formMessages[inputId]?.label.id || '') ? currentLabel : '',
      error: !!errors[inputId],
    };
  };
};
